import './GridButtons.css'

import { useNavigate } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import { axiosPrivate } from '../../../api/axios';

interface GridButtonsProps {
    concertId: number;
    refreshGridData: () => void;
}

const GridButtons = ({concertId, refreshGridData }: GridButtonsProps) => {
    
    const { auth } = useAuth();
    const navigate = useNavigate();

    const addOnClick = () => {
        navigate(`/concert/${concertId}/add-event`);
    }

    const addBulkOnClick = () => {
        navigate(`/concert/${concertId}/add-event?mode=bulk`);
    }

    const printOnClick = async () => {
        try {
            let concertName = String(concertId);
            try {
                const concertResponse = await axiosPrivate.get(`concerts/${concertId}`);
                const location = concertResponse.data[0]?.miejsceKoncertu;
                if (location) concertName = location.replace(/\s+/g, "_");
            } catch {
                alert("Nie można pobrać nazwy koncertu. Pobieranie PDF może się nie powieść.");
            }

            const response = await axiosPrivate.get(`admin/pdf/idk/${concertId}`, {
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = url;
            link.download = `harmonogram_koncertu_${concertName}.pdf`;

            link.click();
            URL.revokeObjectURL(url);
            link.remove();

        } catch (error) {
            console.error("Błąd pobierania PDF:", error);
        }
    };

    const concertsListOnClick = () => {
        navigate('/concertList');
    }

    const artistsOnClick = () => {
        navigate('/artists');
    }

    const bandsOnClick = () => {
        navigate('/bandList');
    }

    const othersOnClick = () => {
        navigate('/otherList');
    }

    const adminOnClick = () => {
        navigate(`/admin`);
    }

    const saveOnClick = () => {
        refreshGridData();
    };

    return (
        <div className="grid-buttons">
            <button className="btn" onClick={addOnClick}>Dodaj</button>
            <button className="btn" onClick={addBulkOnClick}>Dodaj grupowo</button>
            <button className="btn" onClick={printOnClick}>Drukuj</button>
            <button className="btn" onClick={concertsListOnClick}>Lista koncertów</button>
            <button className="btn" onClick={artistsOnClick}>Gwiazdy</button>
            <button className="btn" onClick={bandsOnClick}>Zespoły</button>
            <button className="btn" onClick={othersOnClick}>Inne</button>
            {auth?.role === 'admin' && (
                <button className="btn" onClick={adminOnClick}>Panel Administratora</button>
            )}
            <button className="btn btn-six" onClick={saveOnClick}>Odśwież</button>
        </div>
    )

};

export default GridButtons;
